import BaseEndpoint from '@/api/endpoints/base-endpoint'

export default class DomainContentEndpoint extends BaseEndpoint {}
